import { ACCIDENTAL_ACTION_DEBOUNCE_TIME_SHORT } from "app/pages/sales-intelligence/constants/timeouts";

export const UNKNOWN_ALIAS = "unknown-signal";

export const UNKNOWN_SIGNAL_TRANSLATABLE = { key: "si.signals.text.unknown-signal" };

export const UNKNOWN_COUNTRY = "Unknown country";

export const PERIOD_TO_NAME_MAP: Record<string, string> = {
    mom: "month",
    qoq: "quarter",
    yoy: "year",
};

export const TOOLTIP_DEBOUNCE_TIME = ACCIDENTAL_ACTION_DEBOUNCE_TIME_SHORT;

export const SIGNALS_HELP_ARTICLE_LINK = "https://support.similarweb.com/hc/en-us/articles/11573963021725";